import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const projectVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

const Project = ({ title, linkUrl, description, imageExt = "jpg" }) => {
  const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500
    bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
  const projectTitle = title.split(" ").join("-").toLowerCase();

  const handleProjectClick = () => {
  
    if (linkUrl) {
  
      window.open(linkUrl, '_blank');
    }
  };

  return (
    <motion.div variants={projectVariant} className="relative mb-2 sm:mb-0 cursor-pointer" onClick={handleProjectClick}>
      <div className={overlayStyles}>
        <p className="text-2xl font-playfair">{title}</p>
        <p className="mt-7">
          {description || "Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Nulla porttitor accumsan tincidunt."}
        </p>
      </div>
      <img src={`/assets/${projectTitle}.${imageExt}`} alt={projectTitle} />
      {/* <img src={process.env.PUBLIC_URL + './assets/${projectTitle}.jpeg'} alt="Instagram" /> */}
      {/* <img src={example} alt={projectTitle} /> */}
    </motion.div>
  );
};

const Projects = () => {
  return (
    <section id="projects" className="pt-48 pb-48">
      {/* HEADINGS */}
      <motion.div
        className="md:w-2/5 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-playfair font-semibold text-4xl">
            <span className="text-red">PRO</span>JECTS
          </p>
          <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
          </div>
        </div>
        <p className="mt-10 mb-10">
          A curated collection of projects showcasing my passion for crafting
          beautiful user interfaces and delivering smooth user experiences.
          From CLI tools to enterprise web applications, each project represents
          a unique challenge solved with creativity and technical expertise.
        </p>
      </motion.div>

      {/* PROJECTS */}
      <div className="flex justify-center">
        <motion.div
          className="sm:grid sm:grid-cols-3 md:gap-6"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* ROW 1 */}
          <div
            className="flex justify-center text-center items-center p-10 bg-red
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold "
          >
            BEAUTIFUL USER INTERFACES
          </div>
          <Project title="create-div" description="A simple CLI tool for quickly scaffolding new projects with ease" linkUrl='https://www.npmjs.com/package/create-indv-next-app' imageExt="png"/>
          <Project title="aowe" linkUrl='https://ao.gtbank.com/v1/landing'/>
          <Project title="bpp-homes" linkUrl='https://bppcompanies.com/' imageExt="png"/>
          <Project title="optimus" linkUrl='' imageExt="png"/>

          {/* ROW 2 */}
        
          <Project title="portfolio" linkUrl=''/>
          <Project title="titan" linkUrl='https://titankids.netlify.app/'/>

          {/* ROW 3 */}
          <Project 
            title="innovation-doc" 
            linkUrl='https://www.npmjs.com/package/innovation-doc-gen-cli'
            description="AI-powered documentation generator for JavaScript/TypeScript projects. Automatically generates and updates API documentation and README files using AI. Using Claude, Ollama, or OpenAI."
            imageExt="png"
          />
          <div
            className="flex justify-center text-center items-center p-10 bg-blue
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          >
            SMOOTH USER EXPERIENCE
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
